import React from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  useTheme,
} from '@mui/material';
import { Warning as WarningIcon, Close as CloseIcon } from '@mui/icons-material';

interface PlanInactiveAlertProps {
  onClose: () => void;
  onGoToPlans: () => void;
}

const PlanInactiveAlert: React.FC<PlanInactiveAlertProps> = ({
  onClose,
  onGoToPlans
}) => {
  const theme = useTheme();

  return (
    <Alert
      severity="warning"
      icon={<WarningIcon />}
      action={
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Button
            color="inherit"
            size="small"
            onClick={onGoToPlans}
            sx={{
              fontWeight: 'bold',
              textTransform: 'none',
            }}
          >
            Contratar Plano
          </Button>
          <Button
            color="inherit"
            size="small"
            onClick={onClose}
            sx={{
              minWidth: 'auto',
              p: 0.5,
            }}
          >
            <CloseIcon fontSize="small" />
          </Button>
        </Box>
      }
      sx={{
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%',
        },
        '& .MuiAlert-action': {
          alignItems: 'center',
        },
      }}
    >
      <AlertTitle sx={{ fontWeight: 'bold' }}>
        Plano Inativo - Funcionalidades Limitadas
      </AlertTitle>
      Seu plano expirou. Você ainda pode gerenciar leads, mas o agente de IA no WhatsApp
      e outros recursos avançados estão indisponíveis.
      <Button
        color="inherit"
        size="small"
        onClick={onGoToPlans}
        sx={{
          fontWeight: 'bold',
          textDecoration: 'underline',
          textTransform: 'none',
          ml: 1,
          p: 0,
          minWidth: 'auto',
        }}
      >
        Contrate um plano
      </Button> para desbloquear todas as funcionalidades.
    </Alert>
  );
};

export default PlanInactiveAlert;
